export default [
  {
    name: 'AppConfigs',
    path: '/app-configs',
    component: () => import('./pages/AppConfigs'),
    meta: {
      ability: [
        {
          resource: 'app-configs',
          actions: ['read'],
        },
      ],
    },
  },
  {
    name: 'Add AppConfig',
    path: '/app-configs/add',
    component: () => import('./pages/AppConfigsDetails'),
    meta: {
      ability: [
        {
          resource: 'app-configs',
          actions: ['create'],
        },
      ],
    },
  },
  {
    name: 'Edit AppConfig',
    path: '/app-configs/edit/:id',
    component: () => import('./pages/AppConfigsDetails'),
    meta: {
      ability: [
        {
          resource: 'app-configs/:id',
          actions: ['update'],
        },
      ],
    },
    props: {
      editMode: true,
    },
  },
]
